import React, {useEffect, useContext, useState} from 'react';
import '../../css/market.css';
import { useSelector } from 'react-redux';
import MarketSection from './marketSection';
import CurrentPageHandler from './currentPageHandler';
import PastOrders from './pastOrders';
import { AgentContext } from '../../context/AgentContext';
import * as amplitude from "@amplitude/analytics-browser";


function Market({ data}) {
    const [sections, setSection]=useState(data[0].sections);
    const [leadPreview, setLeadPreview]=useState(data[0].results[0].leads[0]);
    const [workflowPreview, setWorkflowPreview]=useState(data[0].results[0].workflows[0]);

    const [currentPage, setCurrentPage]=useState(null);
    const [pathData, setPathData]=useState(null);

	const agentInfo = useSelector((state) => state.agent.userData);

    const handleNavigation = (name,icon) => {
        if(name === 'Lighthouse Leads'){
            window.open(process.env.REACT_APP_LEAD_STREAM_URL)
        } else {
            setCurrentPage(name);
        }
    };
    const {isB2B} = useContext(AgentContext)

	useEffect(
		() => {
			try {
				amplitude.track(
					"Modal Viewed",
					{
						duration: null, // Figure out what "calculated" means
						Agent_code: agentInfo.agentCode,
					}
				);
			} catch (err) {
				console.error(
					"Market: Exception occurred during Amplitude communication attempt: %s",
					err,
					err,
				);
			}
		},
		[],
	);

    return (
        <div className={`${isB2B ? 'b2b ' : ''}outerWrapper`}>
           <span className="outerWrapperTitle"><span className="outerWrapperIcon"></span>Market</span>
            <div className="mainBlockOuterWrapper">
                <AgentContext.Provider value={{ isB2B }}>
                    {currentPage ? (
                        <CurrentPageHandler pathData={pathData} handleNavigation={handleNavigation} setPathData={setPathData} page={currentPage} setCurrentPage={setCurrentPage} />
                    ) : (
                        <>
                            <PastOrders />
                            {sections ? (
                                sections.map((section, index) => (
                                    <MarketSection key={`markets${index}`} handleNavigation={handleNavigation} title={section.name} workflowPreview={workflowPreview} leadPreview={leadPreview} />
                                ))
                            ) : (
                                null
                            )}
                        </>
                    )}

                </AgentContext.Provider>

        </div>
    </div>

    );
}

export default Market;
